import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export const LoadingScreen = ({ open = true }) => (
  <Backdrop
    sx={{ color: "#fff", zIndex: (t) => t.zIndex.drawer + 1 }}
    open={open}
  >
    <CircularProgress color="inherit" />
  </Backdrop>
);
